<template>
    <div style="width: 100%;">
        <slot v-if="isActive">
            <span style="padding: 5px; display: block">
            <select v-model="selectedMonth" @change="validateValue()" class="form-control" id="month-select">
                <option value="" disabled>Select month</option>
                <option v-for="month in months" :key="month.value" :value="month.value">
                    {{ month.text }}
                </option>
            </select>
            </span>
        </slot>
        <slot v-else>
            <span @click="isActive=true"
                  class="no-selected"
                  :class="{'selected':selectedMonth}">{{ selectedMonth === "" ? 'Month' : selectedMonthName }}</span>
        </slot>
    </div>
</template>

<script>
export default {
    name: "BillingMonth",
    data() {
        return {
            selectedMonth: "",
            months: [
                {value: null, text: "-=Clear=-"},
                {value: "01", text: "January"},
                {value: "02", text: "February"},
                {value: "03", text: "March"},
                {value: "04", text: "April"},
                {value: "05", text: "May"},
                {value: "06", text: "June"},
                {value: "07", text: "July"},
                {value: "08", text: "August"},
                {value: "09", text: "September"},
                {value: "10", text: "October"},
                {value: "11", text: "November"},
                {value: "12", text: "December"}
            ],
            isActive: false,
        };
    },
    computed: {
        selectedMonthName() {
            const month = this.months.find(m => m.value === this.selectedMonth);
            return month ? month.text : "";
        }
    },
    methods: {
        validateValue() {
            this.isActive = false;
            this.$emit('selected', this)
        }
    }
};
</script>

<style scoped>
.no-selected {
    display: block;
    width: 100%;
    height: 100%;
    text-align: center;
    padding: 5px;
}

.no-selected:hover {
    background: #dfdfdf;
}

.selected {
    font-weight: 600;
}
</style>
